import imagesLoaded from 'imagesloaded';
import Isotope from 'isotope-layout';
import { initMDCRipples } from './ripple';
import { initMDCTabBarScroller } from './tabs';

export function initIsotopeFooterMenus() {
	const menusContainer = document.querySelector( '.pbsm-colophon__menus-inner');
	if (menusContainer) {
		const isotopeInstance = new Isotope(menusContainer, {
			itemSelector: '.pbsm-colophon__menu-container', 
			percentPosition: true, 
			masonry: {
				columnWidth: '.pbsm-colophon__menu-container',
				gutter: '.pbsm-colophon__menu-gutter', // note: the actual width must be set in sass, as this only handles horizontal gutter. 
			}
		});

		isotopeInstance.layout();
	}
}

export function initIsotopeGalleries() {

	function filterByMediaCat(element, selected) {
		if (element && selected) {
			const mediaCatId = parseInt(element.getAttribute('data-media-cat'), 10);
			return ((selected === 0) || (mediaCatId === selected));
		} else {
			return false;
		}
	}

	const containers = document.querySelectorAll('.pbsm-gallery');

	if (containers.length > 0) {
		containers.forEach((container, containerIndex) => {
			const gallery = container.querySelector('.gallery');
			
			if (gallery) {
				const filtersContainer = container.querySelector('.pbsm-gallery__filters');

				// Init filters
				if (filtersContainer) {
					const filters = filtersContainer.querySelectorAll('.mdc-tab');

					// Init isotope
					const isotopeInstance = new Isotope(gallery, {
						itemSelector: '.gallery-item', 
						percentPosition: true, 
						masonry: {
							columnWidth: '.gallery-item',
							gutter: '.gallery-gutter', // note: the actual width must be set in sass, as this only handles horizontal gutter. 
						}, 
						getSortData: {
							mediaCatId: '[data-media-cat]', 
						}
					});

					imagesLoaded(gallery, { background: true }, () => {
						// get the filters again, as some have now been cleaned, 
						// and counts have been added.
						const newFilters = filtersContainer.querySelectorAll('.mdc-tab');
						if (newFilters && (newFilters.length > 0)) { 
							const selected = (newFilters && (newFilters.length > 0)) ? parseInt(newFilters[0].getAttribute('data-media-cat'), 10) : 0;
							// layout Isotope after each image loads
							setTimeout(() => {
								isotopeInstance.arrange({
									filter: (element) => {
										return filterByMediaCat(element, selected);
									}, 
								});
								filtersContainer.style.display = null;
								// init MDC Tab Bar Scroller Filters
								initMDCTabBarScroller(filtersContainer);
							}, 250);
						} else {
							const parent = filtersContainer.parentNode;
							parent.removeChild(filtersContainer);
							setTimeout(() => {
								isotopeInstance.layout();
							}, 250);
						}
					});

					isotopeInstance.on('layoutComplete', () => {
						// layout ripples when the gallery is rebuilt.
						initMDCRipples(gallery, 250);
					});

					// Count cats.
					let catCounts = {};
					const items = gallery.querySelectorAll('.gallery-item');
					if (items && (items.length > 0)) {
						items.forEach((item, itemIndex) => {
							const mediaCatId = item.getAttribute('data-media-cat');
							if (catCounts[mediaCatId]) {
								catCounts[mediaCatId]++;
							} else {
								catCounts[mediaCatId] = 1;
							}
						});
					} 

					if (filters && (filters.length > 0)) {
						filters.forEach((filter, filterIndex) => {
							const filterMediaCatId = parseInt(filter.getAttribute('data-media-cat'), 10);
							let catCount = 0;
							if (filterMediaCatId === 0) {
								catCount = items.length;
							} else if (catCounts[filterMediaCatId]) {
								catCount = catCounts[filterMediaCatId];
							}
							const countFormatted = new Intl.NumberFormat().format(catCount);
							const countString = document.createTextNode(` (${countFormatted})`); 
							const parentNode = filter.parentNode;
							filter.appendChild(countString);
							if (! catCount > 0) {
								parentNode.removeChild(filter);
							} 
							// Add event listener to all filters.
							filter.addEventListener('click', (e) => {
								e.preventDefault();
								const selected = parseInt(e.target.getAttribute('data-media-cat'), 10);
								isotopeInstance.arrange({
									filter: (element) => {
										return filterByMediaCat(element, selected);
									}, 
								});
							});
						});
					}
				}
			}
		});
	}

}